import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SingleUser } from "../../../utilities/api/user/user-service";



const initialState = {
    SingleUserDataList: {}
}

export const SingleUserData = createAsyncThunk("UserList/SingleUser", (id: string) => SingleUser(id))

const SingleUserDataSlice = createSlice({
    name: "SingleUser",
    initialState,
    reducers: {
        resetSingleUserSlice: () => initialState
    },
    extraReducers: (builder) => {
        builder

            .addCase(SingleUserData.fulfilled, (state, action: PayloadAction<any>) => {
                state.SingleUserDataList = action.payload.data
            })

    }

})

export default SingleUserDataSlice.reducer
export const { resetSingleUserSlice } = SingleUserDataSlice.actions